import React from 'react';
import { JSONTree } from 'react-json-tree';

import { RicosDocumentJTD } from './../../../ricos-schema/next-schema/index.js';

import { Button } from '../components/Button.js';
import { jsonTreeTheme } from '../theme.js';

export const RicosSchemaTab: React.FC = () => {
  const [openedRef, setOpenedRef] = React.useState<string | null>(null);
  React.useEffect(() => {
    if (!openedRef) {
      return;
    }
    const el = document.querySelector(`[data-definition="${openedRef}"]`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [openedRef]);
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <p style={{ color: 'rgba(205, 214, 244, .8)' }}>
          Ricos schema is defined in JSON Typedef, you can read more about it{' '}
          <a
            target="_blank"
            style={{ color: jsonTreeTheme.base0A }}
            href="https://jsontypedef.com/docs/jtd-in-5-minutes/"
            rel="noreferrer"
          >
            here.
          </a>
        </p>
        <Button
          onClick={() => {
            // oxlint-disable-next-line no-console
            console.log(RicosDocumentJTD);
          }}
        >
          Log Schema
        </Button>
      </div>
      <JSONTree
        collectionLimit={0}
        labelRenderer={path => {
          if (path.length === 2 && path[1] === 'definitions') {
            return <span data-definition={path[0]}>{path[0]}</span>;
          }
          return path[0];
        }}
        valueRenderer={(valueAsString, value, ...nodePath) => {
          if (nodePath[0] === 'ref') {
            return (
              <span>
                {valueAsString}
                <Button
                  onClick={() => {
                    setOpenedRef(value);
                  }}
                >
                  open
                </Button>
              </span>
            );
          }
          return valueAsString;
        }}
        data={RicosDocumentJTD}
        invertTheme={false}
        theme={jsonTreeTheme}
        hideRoot
        shouldExpandNode={path => {
          const rev = [...path].reverse();
          if (rev.length === 1 && rev[0] === 'definitions') {
            return true;
          }
          if (rev.length === 2 && rev[0] === 'definitions' && openedRef && openedRef === rev[1]) {
            return true;
          }
          return false;
        }}
      />
    </div>
  );
};
